import { message } from 'antd';
import { call, onSuccess } from 'actionware';
import { sessionService } from 'redux-react-session';
import { push } from 'connected-react-router';
import { apiFetch, griffinInstance } from '../../common/helpers';
import {jwtDecoder} from '../../utils/jwtDecoder';
import { authenticatedApiFetch } from '../../common/helpers';
import { getLogoutURL } from '../../helpers/auth';

export async function authLogin(userData) {
  // return {
  //   id: 1,
  //   userName: 'John Doe',
  //   email: 'john.doe@gmail.com',
  //   memberSince: '2017-01-01'
  // };
  // TODO: uncomment this when auth works
  // return apiFetch('auth/signin', 'POST', userData);
  return apiFetch('login', 'POST', {...userData, productId: 'lender-dashboard'});
}

export async function authLogout() {
  sessionService.deleteSession();
  sessionService.deleteUser();
  window.location.href = getLogoutURL();
}

export async function resetPassword(recoverEmail) {
  return apiFetch('user/forgot-password', 'POST', {
    email: recoverEmail
  })
  .then(data => {
    return { data, recoverEmail }
  })
}

export function resendPasswordReset({ getState }) {
  const { login: { email } } = getState();
  call(resetPassword, email);
}

export function showLogin() {
  return true;
}

export function forgotPassword() {
  return true;
}

export function timeLeftTick(resendCountdown) {
  return resendCountdown;
}

// Side effects
// ------------------------------

onSuccess(authLogin, async ({ store: { dispatch, getState } }) => {
  const { login: { user } } = getState();
  const { payload: { data }} = jwtDecoder(user.data);
  await sessionService.saveSession({
    authToken: user.data,
    roles: data.roles[0],
    lenderId: data.lenderId
  });
  await sessionService.saveUser(user);
  message.success('You logged in successfully');
  dispatch(push('/'));
});


onSuccess(resetPassword, async ({ store: { getState } }) => {
  const interval = setInterval(() => {
    let { login: { resendCountdown } } = getState();
    if (resendCountdown > 0) {
      call(timeLeftTick, --resendCountdown);
    } else {
      clearInterval(interval);
    }
  }, 1000);
});
